<template>
<div>
      <page-title-bar></page-title-bar>
		<v-container fluid pt-0 grid-list-xl>
<v-layout row wrap>
            	<app-card 
						:heading="$t('message.services')"
						colClasses="xl12 lg12 md12 sm12 xs12"
						customClasses="mb-0">

            <OnlineStructureMaster :isChild="false" v-on:refreshControlRoot="refreshControlEvt"></OnlineStructureMaster>
 
  </app-card>
</v-layout>
		</v-container>
        </div>
</template>
<script>

import OnlineStructureMaster from "../../views/onlinereservation/OnlineStructureMaster.vue";

export default {
  components: {
    OnlineStructureMaster 
  },
  data() {
    return {
      dataSource: [],
      autoExpandAll: true,
    };
  },
  mounted() {
  },
  methods: {
    refreshControlEvt (item) {
       console.log ("refreshing control root...");
       this.loader = false;
    }
  }
};
</script>